import React from 'react';

export const AuthContext = React.createContext<{
  authToken: string | null;
  setAuthToken: (token: string | null) => void;
} | null>(null);
